import * as React from "react";

interface Props extends React.SVGProps<SVGSVGElement> {
    size?: number;
}

const ExcelIcon = ({ size = 15, ...props }: Props) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 38 45"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g opacity={0.3}>
            <path
                opacity={0.3}
                d="M26.0402 9.18221C25.0209 9.18122 24.0436 8.77585 23.3229 8.0551C22.6021 7.33434 22.1968 6.35707 22.1958 5.33778V0H5.01715C3.68653 0 2.41039 0.528603 1.4695 1.4695C0.528603 2.41039 0 3.68648 0 5.0171V35.2615C0 36.5921 0.528603 37.8683 1.4695 38.8092C2.41039 39.7501 3.68653 40.2787 5.01715 40.2787H25.6375C26.9681 40.2787 28.2442 39.7501 29.1851 38.8092C30.126 37.8683 30.6546 36.5921 30.6546 35.2615V9.18221H26.0402Z"
                fill="#00C650"
            />
        </g>
        <path
            d="M30.6546 9.18221H26.0402C25.0209 9.18122 24.0437 8.77585 23.3229 8.0551C22.6022 7.33434 22.1968 6.35707 22.1958 5.33778V0L30.6546 9.18221Z"
            fill="#00C650"
        />
        <path
            d="M34.2939 31.8086H10.9813C9.32764 31.8086 7.98706 33.1492 7.98706 34.8028V41.7533C7.98706 43.407 9.32764 44.7476 10.9813 44.7476H34.2939C35.9475 44.7476 37.2881 43.407 37.2881 41.7533V34.8028C37.2881 33.1492 35.9475 31.8086 34.2939 31.8086Z"
            fill="#00C650"
        />
        <path d="M16.3006 39.7822V41.1377H14.8967V39.7822H16.3006Z" fill="white" />
        <path
            d="M20.4078 41.1385L19.2276 39.3934L18.2115 41.1385H16.6585L18.4502 38.2524L16.6025 35.5322H18.2115L19.3619 37.2213L20.3537 35.5322H21.8993L20.1318 38.3549L22.0187 41.1385H20.4078Z"
            fill="white"
        />
        <path
            d="M26.3442 40.3771C26.1834 40.6345 25.9525 40.8408 25.6786 40.9718C25.3453 41.1279 24.9801 41.2039 24.6122 41.1937C24.0571 41.2169 23.5102 41.0549 23.0573 40.7332C22.857 40.5828 22.6931 40.3893 22.5779 40.1669C22.4626 39.9445 22.399 39.699 22.3917 39.4486H23.8347C23.845 39.6374 23.9255 39.8156 24.0603 39.9482C24.1946 40.0734 24.3728 40.1404 24.5562 40.1347C24.631 40.1391 24.7059 40.1286 24.7766 40.104C24.8473 40.0794 24.9125 40.041 24.9683 39.9911C25.018 39.9429 25.0571 39.8848 25.0832 39.8206C25.1092 39.7564 25.1215 39.6875 25.1193 39.6182C25.1211 39.5525 25.1097 39.4871 25.0857 39.4259C25.0617 39.3647 25.0255 39.3091 24.9795 39.2622C24.8808 39.1623 24.7637 39.0825 24.6346 39.0272C24.4991 38.9676 24.3089 38.8948 24.0641 38.8091C23.7669 38.7111 23.4767 38.5934 23.1953 38.4567C22.964 38.3376 22.7655 38.1634 22.6173 37.9496C22.4453 37.6908 22.3603 37.3838 22.3749 37.0733C22.3682 36.7657 22.4567 36.4635 22.6285 36.2082C22.8048 35.9588 23.0487 35.7648 23.3314 35.6489C23.6572 35.5164 24.007 35.4529 24.3586 35.4625C24.8925 35.433 25.4199 35.5906 25.8502 35.9081C26.0333 36.0571 26.1833 36.2426 26.2905 36.4529C26.3977 36.6632 26.4598 36.8935 26.4729 37.1292H25.0056C24.9892 36.9643 24.9184 36.8095 24.8042 36.6893C24.7459 36.6334 24.6768 36.59 24.6012 36.5618C24.5255 36.5336 24.4449 36.5211 24.3642 36.5252C24.2244 36.5188 24.0871 36.564 23.9783 36.652C23.9281 36.6996 23.889 36.7577 23.8639 36.8221C23.8387 36.8866 23.8282 36.9558 23.8329 37.0249C23.83 37.1502 23.8769 37.2715 23.9634 37.3623C24.0561 37.4592 24.1678 37.536 24.2915 37.5879C24.4239 37.6457 24.6141 37.7203 24.862 37.8098C25.1645 37.9083 25.4593 38.0292 25.7439 38.1715C25.9763 38.2969 26.1767 38.4742 26.3293 38.6898C26.5033 38.9527 26.5894 39.2641 26.5754 39.5791C26.5729 39.8612 26.4929 40.1373 26.3442 40.3771Z"
            fill="white"
        />
        <path
            d="M28.6802 40.1H30.4962V41.1385H27.3267V35.5322H28.684L28.6802 40.1Z"
            fill="white"
        />
        <path
            d="M22.1658 28.1228H8.49595C7.31205 28.1228 6.34814 26.9444 6.34814 25.4939V15.5772C6.34814 14.1285 7.31205 12.9502 8.49595 12.9502H22.1714C23.3534 12.9502 24.3173 14.1285 24.3173 15.5772V25.4939C24.3117 26.9444 23.3478 28.1228 22.1658 28.1228ZM8.49595 14.2926C7.91611 14.2926 7.44631 14.8687 7.44631 15.5772V25.4939C7.44631 26.2024 7.91611 26.7785 8.49595 26.7785H22.1714C22.7494 26.7785 23.2192 26.2024 23.2192 25.4939V15.5772C23.2192 14.8687 22.7494 14.2926 22.1714 14.2926H8.49595Z"
            fill="#00C650"
        />
        <path
            d="M23.7636 22.1504H6.89258V23.4946H23.7636V22.1504Z"
            fill="#00C650"
        />
        <path d="M23.7636 17.542H6.89258V18.8862H23.7636V17.542Z" fill="#00C650" />
        <path
            d="M19.4421 13.6211H18.0979V27.4494H19.4421V13.6211Z"
            fill="#00C650"
        />
        <path
            d="M12.5569 13.6211H11.2126V27.4494H12.5569V13.6211Z"
            fill="#00C650"
        />
    </svg>
);
export default ExcelIcon;
